var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAviaoBgInverse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 578,
    height: 765,
    viewBox: "0 0 578 765",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_134_2363)",
    id: "g100",
    transform: "matrix(-1,0,0,1,533.99427,-4.0529411)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_134_2363",
    maskUnits: "userSpaceOnUse",
    x: 56,
    y: 147,
    width: 667,
    height: 548
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 56.0228,350.492 592.181,694.019 722.226,491.051 186.069,147.524 Z",
    fill: "#ffffff",
    id: "path85"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_134_2363)",
    id: "g98"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    id: "g96"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 56.0227,350.493 214.422,397.196 189.525,367.482 Z",
    fill: "#3f53d7",
    id: "path88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 189.526,367.481 6.496,-29.475 -139.9986,12.486 z",
    fill: "#d3daf4",
    id: "path90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 187.971,364.655 56.023,350.492 141.421,323.584 Z",
    fill: "#3f53d7",
    id: "path92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 719.272,493.112 c -55.401,-44.55 -126.38,-72.9 -197.176,-66.382 -31.252,2.858 -63.848,13.682 -83.953,37.969 -8.031,9.728 -13.876,23.34 -8.583,34.773 2.913,5.528 7.387,10.078 12.866,13.082 8.365,5.056 17.806,8.063 27.554,8.777 9.747,0.715 19.526,-0.884 28.54,-4.666 9.013,-3.782 17.005,-9.64 23.323,-17.095 6.32,-7.457 10.788,-16.301 13.042,-25.812 4.527,-19.261 -0.56,-39.943 -10.738,-56.861 C 513.966,399.979 498.968,386.349 482.946,374.775 404.5,317.976 294.495,308.394 207.259,350.468",
    stroke: "#000000",
    strokeWidth: 1.32811,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.75, 3.75",
    id: "path94"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs105"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_134_2363"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 589.554,
    height: 510.153,
    fill: "white",
    transform: "translate(290.936 764.52) rotate(-119.57)",
    id: "rect102"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAviaoBgInverse);
export default __webpack_public_path__ + "static/media/aviao-bg-inverse.d3e86bcfc76cdf104d087767ace70615.svg";
export { ForwardRef as ReactComponent };